import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Plugin_getInstancedvtd2m29fslb as Plugin_getInstance } from '../HttpSend.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SetupRequest$install$slambda($handler) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    yield* $($handler($this$intercept.w4v_1, $completion), $completion);
    return Unit_instance;
  }), 2);
}
var SetupRequestClass;
function SetupRequest() {
  if (SetupRequestClass === VOID) {
    class $ {
      a5w(client, handler) {
        var tmp = Phases_getInstance().p5p_1;
        client.n5j_1.a4w(tmp, SetupRequest$install$slambda(handler));
      }
      u5p(client, handler) {
        return this.a5w(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequest');
    SetupRequestClass = $;
  }
  return SetupRequestClass;
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
var SenderClass;
function Sender() {
  if (SenderClass === VOID) {
    class $ {
      constructor(httpSendSender, coroutineContext) {
        this.g5s_1 = httpSendSender;
        this.h5s_1 = coroutineContext;
      }
      ww() {
        return this.h5s_1;
      }
      *i5s(requestBuilder, $completion) {
        return yield* this.g5s_1.g5u(requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'Sender', VOID, VOID, VOID, [1]);
    SenderClass = $;
  }
  return SenderClass;
}
function Send$install$slambda($handler, $client) {
  return constructCallableReference(($this$intercept, request, $completion) => orPromise($completion, function *($completion) {
    return yield* $($handler(new (Sender())($this$intercept, $client.m5j_1), request, $completion), $completion);
  }), 2);
}
var SendClass;
function Send() {
  if (SendClass === VOID) {
    class $ {
      b5w(client, handler) {
        var tmp = plugin(client, Plugin_getInstance());
        tmp.w5u(Send$install$slambda(handler, client));
      }
      u5p(client, handler) {
        return this.b5w(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Send');
    SendClass = $;
  }
  return SendClass;
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
//region block: init
SetupRequest_instance = new (SetupRequest())();
Send_instance = new (Send())();
//endregion
//region block: exports
export {
  Send_instance as Send_instance1oebf6ttzyqzk,
  SetupRequest_instance as SetupRequest_instance2zzqkp8zxmw91,
};
//endregion

//# sourceMappingURL=CommonHooks.mjs.map
